module.exports = __webpack_public_path__ + "static/media/cd.448b8d3d.jpg";